import { render, staticRenderFns } from "./createdButton.vue?vue&type=template&id=fb282d28&scoped=true"
import script from "./createdButton.vue?vue&type=script&lang=js"
export * from "./createdButton.vue?vue&type=script&lang=js"
import style0 from "./createdButton.vue?vue&type=style&index=0&id=fb282d28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb282d28",
  null
  
)

export default component.exports